export default {"src":"/_next/static/media/bottle-size.4d53ed97.svg","height":20,"width":24,"blurWidth":0,"blurHeight":0};